import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { UserModel } from '../models/user.model';
import { InfraService } from './infra.service';
import { MasterLanguage } from '../models/MasterLanguage.model';
import { map, tap } from 'rxjs/operators';

@Injectable()
export class UserService {
  private configUrl: string;
  private coreAPIUrl: string = `${environment.apiUrl}User`;

  private loggedInUserData = new BehaviorSubject<UserModel>(new UserModel());
  cast = this.loggedInUserData.asObservable();

  constructor(private infraService: InfraService, private http: HttpClient) {
    this.infraService.infraDetails$.subscribe(data => {
      this.configUrl = data.WebEndPoint1 + 'users';
      if (data.WebEndPoint2) {
        this.coreAPIUrl = data.WebEndPoint2 + 'User';
      }
    });

    if (!this.infraService.isInfraDetailsAvailable && localStorage.getItem('selectedInfra') != undefined) {
      this.infraService.isInfraDetailsAvailable = true;
      this.infraService.setInfraDetails(localStorage.getItem('selectedInfra'));
    }
  }

  setLoggedInUserData(loggedInData: UserModel) {
    this.loggedInUserData.next(loggedInData);
  }

  public captureUserProfile(): Observable<UserModel[]> {
    return this.http.post<UserModel | UserModel[]>(`${this.coreAPIUrl}/CaptureUserProfile`,{}).pipe(
      map(profile => Array.isArray(profile) ? profile : profile ? [profile] : []),
      tap(profile => {
        if (profile.length > 0) {
          this.setLoggedInUserData(profile[0]);
          localStorage.setItem('loggedInUserId', String(profile[0].Id));
        }
      })
    );
    // .catch(this.handleError);
  }

  private handleError(error: Response) {
    return throwError(()=> error);
  }

  public getADUsers(name: string): Observable<UserModel[]> {
    return this.http.get<UserModel[]>(`${this.coreAPIUrl}/SearchAdUsers/${name}`);
    // .catch(this.handleError);
  }

  public updateUserPrivacyPolicyFlag(userModel: UserModel) {
    return this.http.post(`${this.coreAPIUrl}/UpdatePrivacyPolicyFlag/${userModel.Id}`, userModel);
    // .catch(this.handleError);
  }

  public UpdateUserLanguage(currrentUserId: number, code: any) {
    return this.http.post(`${this.coreAPIUrl}/UpdateUserLanguage/${currrentUserId}/${code}`, {});
    // .catch(this.handleError)
  }
  

  public GetAllVisibleLanguages(): Observable<MasterLanguage[]> {
    return this.http.get<MasterLanguage[]>(`${this.coreAPIUrl}/GetAllVisibleLanguages`);
    // .catch(this.handleError);
  }


  public GetAllUsers(): Observable<UserModel[]> {
    return this.http.get<UserModel[]>(`${this.coreAPIUrl}/GetAllUsers`);
    // .catch(this.handleError);
  }

}
